import { FBaseService } from '@kasasa/fbase-components/lib';
import { AxiosResponse } from 'axios';
import { KasasaUpgrade } from './KasasaUpgrade';

export default class KasasaUpgradeResource extends FBaseService {
  public async getAll(fiId: number | string): Promise<KasasaUpgrade[]> {
    const url = `/api/rcx/config/${fiId}/kasasa-account-upgrades`;

    const upgrades: KasasaUpgrade[] = [];
    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      return response.data.data;
    } catch (error) {
      console.log(JSON.stringify(error));
      return [];
    }
  }


  public async save(fiId: string, kasasaUpgrade: KasasaUpgrade): Promise<KasasaUpgrade> {
    const url = `/api/rcx/config/${fiId}/kasasa-account-upgrades`;
    try {
      const response: AxiosResponse = await this.apiClient.put(url, kasasaUpgrade);
      return response.data.data;
    } catch (error) {
      console.log(JSON.stringify(error));
      throw error;
    }
  }

  public async delete(fiId: string, kasasaUpgrade: KasasaUpgrade): Promise<KasasaUpgrade> {
    const url = `/api/rcx/config/${fiId}/kasasa-account-upgrades/${kasasaUpgrade.id}`;
    try {
      const response: AxiosResponse = await this.apiClient.delete(url);
      return response.data.data;
    } catch (error) {
      console.log(JSON.stringify(error));
      throw error;
    }
  }

  public static createEmptyUpgrade(fiId : string) : KasasaUpgrade {
    return {
      id: undefined,
      fiId: Number.parseInt(fiId, 10),
      startDate: '',
      endDate: '',
      fromAccountProductCodes: [],
      toKasasaProducts: [],
    };
  }
}
